import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'arm-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  @Input() title: string;
  @Input() disabled: boolean;
  @Input() hideCancelButton = false;
  @Input() hideOkButton = false;
  @Input() confirmButtonName = 'OK';
  @Input() cancelButtonName = 'Cancel';
  @Output() onCancel: any = new EventEmitter<any>();
  @Output() onSubmit: any = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  cancel(): void {
    this.onCancel.emit();
  }

  submit(): void {
    this.onSubmit.emit();
  }
}
